const seoConfig = {
  // Default SEO Configuration
  default: {
    title: "Hotel Paku Mas - Hotel Heritage di Yogyakarta",
    description: "Hotel Paku Mas adalah hotel heritage dengan suasana rindang di lokasi strategis Yogyakarta, tepat di depan Ambarukmo Plaza. Cocok untuk liburan keluarga dengan suasana nyaman.",
    keywords: "hotel heritage yogyakarta, hotel keluarga yogyakarta, hotel di depan ambarukmo plaza, penginapan yogyakarta, hotel rindang yogyakarta",
    author: "Hotel Paku Mas",
    ogImage: "/images/hotel-pakumas-og.jpg",
    twitterHandle: "@pakumashotel",
    siteName: "Hotel Paku Mas",
    locale: "id_ID",
  },

  // Home Page SEO
  home: {
    title: "Hotel Paku Mas Yogyakarta - Heritage, Rindang, Nyaman",
    description: "Nikmati penginapan nyaman dengan suasana heritage dan rindang di Hotel Paku Mas. Lokasi strategis di depan Ambarukmo Plaza, cocok untuk liburan keluarga.",
    keywords: "hotel heritage yogyakarta, hotel keluarga yogyakarta, penginapan yogyakarta, hotel dekat ambarukmo plaza",
  },

  // Room Listing Page SEO
  rooms: {
    title: "Kamar Hotel Paku Mas - Nyaman & Bernuansa Heritage",
    description: "Pilih kamar terbaik di Hotel Paku Mas dengan suasana heritage yang nyaman. Penginapan ideal untuk liburan keluarga di Yogyakarta.",
    keywords: "kamar hotel heritage yogyakarta, penginapan keluarga yogyakarta, hotel dekat ambarukmo plaza, hotel rindang yogyakarta",
  },

  // Booking Page SEO
  booking: {
    title: "Booking Hotel Paku Mas - Hotel Heritage Yogyakarta",
    description: "Pesan kamar di Hotel Paku Mas dengan harga terbaik. Hotel heritage dengan lokasi strategis di depan Ambarukmo Plaza, Yogyakarta.",
    keywords: "booking hotel paku mas, hotel heritage yogyakarta, hotel keluarga yogyakarta, penginapan yogyakarta, hotel dekat ambarukmo plaza",
  },

  // Promotion Page SEO
  promotion: {
    title: "Promo Hotel Paku Mas - Diskon Hotel Heritage Yogyakarta",
    description: "Dapatkan diskon spesial dan promo terbaik di Hotel Paku Mas. Suasana heritage yang rindang, cocok untuk liburan keluarga di Yogyakarta.",
    keywords: "promo hotel yogyakarta, hotel heritage yogyakarta, penginapan keluarga yogyakarta, hotel dekat ambarukmo plaza",
  },

  // Social Media Links
  social: {
    facebook: "https://facebook.com/pakumashotel",
    twitter: "https://twitter.com/pakumashotel",
    instagram: "https://instagram.com/pakumashotel",
    linkedin: "https://linkedin.com/company/pakumashotel",
  },

  // Hotel Information for Schema.org
  hotelInfo: {
    name: "Hotel Paku Mas",
    description: "Hotel Paku Mas adalah hotel heritage dengan suasana rindang di Yogyakarta. Menyediakan kamar nyaman untuk liburan keluarga dengan lokasi strategis di depan Ambarukmo Plaza.",
    priceRange: "Rp 300.000 - Rp 500.000",
    rating: {
      value: 4.6,
      count: 850, 
    },
    address: {
      streetAddress: "Jl. Adisucipto No.44, Ambarukmo, Kec. Depok, Kabupaten Sleman, Daerah Istimewa Yogyakarta",
      addressLocality: "Yogyakarta",
      addressRegion: "Daerah Istimewa Yogyakarta",
      postalCode: "55281",
      addressCountry: "ID",
    },
    geo: {
      latitude: "-7.7826423",
      longitude: "110.3976922",
    },
    telephone: "(0274) 485888",
    email: "info@pakumashotel.com",
  },

  // Generate Schema.org JSON-LD
  generateHotelSchema: () => {
    return {
      "@context": "https://schema.org",
      "@type": "Hotel",
      name: seoConfig.hotelInfo.name,
      description: seoConfig.hotelInfo.description,
      priceRange: seoConfig.hotelInfo.priceRange,
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: seoConfig.hotelInfo.rating.value,
        reviewCount: seoConfig.hotelInfo.rating.count,
      },
      address: {
        "@type": "PostalAddress",
        ...seoConfig.hotelInfo.address,
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: seoConfig.hotelInfo.geo.latitude,
        longitude: seoConfig.hotelInfo.geo.longitude,
      },
      telephone: seoConfig.hotelInfo.telephone,
      email: seoConfig.hotelInfo.email,
    };
  },

  // Generate metadata for Next.js pages
  generateMetadata: (page = 'default') => {
    const pageConfig = seoConfig[page] || seoConfig.default;
    const baseUrl = "https://booking.pakumashotel.com";
    const canonicalUrl = `${baseUrl}${page === 'home' ? '' : `/${page}`}`;
    
    return {
      title: pageConfig.title,
      description: pageConfig.description,
      keywords: pageConfig.keywords,
      openGraph: {
        title: pageConfig.title,
        description: pageConfig.description,
        type: "website",
        url: canonicalUrl,
        site_name: seoConfig.default.siteName,
        locale: seoConfig.default.locale,
        images: [{ 
          url: seoConfig.default.ogImage,
          width: 1200,
          height: 630,
          alt: `${seoConfig.hotelInfo.name} - ${pageConfig.title}`
        }],
        address: {
          street: seoConfig.hotelInfo.address.streetAddress,
          locality: seoConfig.hotelInfo.address.addressLocality,
          region: seoConfig.hotelInfo.address.addressRegion,
          postalCode: seoConfig.hotelInfo.address.postalCode,
          addressCountry: seoConfig.hotelInfo.address.addressCountry,
        },
        geo: {
          latitude: seoConfig.hotelInfo.geo.latitude,
          longitude: seoConfig.hotelInfo.geo.longitude,
        }
      },
      twitter: {
        card: 'summary_large_image',
        site: seoConfig.default.twitterHandle,
        creator: seoConfig.default.twitterHandle,
        title: pageConfig.title,
        description: pageConfig.description,
        images: [seoConfig.default.ogImage],
      },
      alternates: {
        canonical: canonicalUrl,
      },
      robots: {
        index: true,
        follow: true,
      },
      schema: seoConfig.generateHotelSchema(),
    };
  },
};

export default seoConfig;
